const awsRumStatusTypes = {
    STARTED: 'STARTED',
    FAILED: 'FAILED',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};

export default awsRumStatusTypes;
